module.exports = __webpack_public_path__ + "img/Fullscreen_blue.8fe892e7.svg";